/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-curly-newline */
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { icons } from '~/assets';
import Button from '~/components/button';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Grid from '~/components/grid';
import Loading from '~/components/loading';
import Input, { MaskTypes } from '~/components/newInput';
import RadioButton from '~/components/radioButton';
import Select from '~/components/select';
import useApi, { ApiMethod } from '~/hooks/useApi';
import { CompanyDataBodyRequest } from '~/services/banknow/types';
import Endpoints from '~/services/endpoints';
import { httpRequest } from '~/services/httpRequest';
import { cpfCnpjExtendedMask } from '~/utils/masks';
import BankData from '~/views/Teupag/parameters/components/BankData';
import GeneralAgreementData from '~/views/Teupag/parameters/components/GeneralAgreementData';
import GeneralData from '~/views/Teupag/parameters/components/GeneralData';
import MDRData from '~/views/Teupag/parameters/components/MDRData';
import {
  onSubmitEstabilishment,
  uploadPhotosOnEstabilishmentCreation,
} from '../../actions';
import { ChangeStatusModal } from './ChangeStatusModal';
import { EstabilishmentImages } from './images';
import { ShowWhereIsAcceptedToogle } from './ShowWhereIsAcceptedToogle';
import { FaSearch, FaMapMarkerAlt } from 'react-icons/fa';
import MapLocationModal from './MapLocationModal';

const CNPJEstablishment = ({
  form,
  setForm,
  handleGetCep,
  handleGetAddressByGeolocation,
}: {
  form: CompanyDataBodyRequest;
  setForm: React.Dispatch<React.SetStateAction<CompanyDataBodyRequest>>;
  handleGetCep: () => void;
  handleGetAddressByGeolocation: (lat: number, lon: number) => void;
}) => {
  const [dialogError, setDialogError] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [dialogGoBack, setDialogGoBack] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [groups, setGroups] = useState([]);
  const [categories, setCategories] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [associateToGroup, setAssociateToGroup] = useState<boolean | null>(
    null,
  );
  const [isMainCompanyAnswered, setIsMainCompanyAnswered] = useState<
    boolean | null
  >(null);
  const [openMap, setOpenMap] = useState(false);

  const buildAddressQuery = () => {
    const { companyData } = form;
    return [
      companyData?.addressStreet,
      companyData?.addressNumber,
      companyData?.addressDistrict,
      companyData?.addressCity,
      companyData?.addressState,
      companyData?.addressZipCode?.masked,
    ]
      .filter(Boolean)
      .join(', ');
  };

  const handleSelectLocation = (latitude: number, longitude: number) => {
    setForm((prev) => ({
      ...prev,
      companyData: {
        ...prev.companyData,
        addressLatitude: latitude,
        addressLongitude: longitude,
      },
    }));
    handleGetAddressByGeolocation(latitude, longitude);
  };

  console.log('CNPJ FORM', form);

  const isSubmitting = useRef(false);
  const generalAgreementRef = useRef();

  const { state } = useLocation<{ document?: string; id?: string }>();

  const isEditing = !!state?.id || !!state?.document;
  const handleStatusChanged = (nextStatus: boolean) => {
    setForm((prev) => ({
      ...prev,
      active: nextStatus,
    }));
  };

  const handleWhereAcceptedChanged = (nextStatus: boolean) => {
    setForm((prev) => ({
      ...prev,
      shouldFilterByLocation: nextStatus,
    }));
  };

  const updateNestedValue = (obj, path, value) => {
    if (!path.length) return value;
    const [key, ...rest] = path;
    return { ...obj, [key]: updateNestedValue(obj[key] || {}, rest, value) };
  };
  const handleChange = ({ target: { value, name } }) => {
    // setForm((prev) => ({ ...prev, [name]: value }));
    setForm((prev) => updateNestedValue(prev, name.split('.'), value));
  };

  const getBusinesscGroups = async () => {
    const params = new URLSearchParams({
      showParameters: 'true',
      page: '1',
      limit: '100',
      sort: 'NAME_ASC',
    });

    const url = `${
      Endpoints.companies.getBusinessGroupsV2
    }?${params.toString()}`;

    const response = await httpRequest({
      url,
      method: ApiMethod.GET,
    });

    setGroups(
      response.data?.data?.map((e) => ({
        id: e.id,
        value: e?.name,
        principalGroupCompany: e?.principalGroupCompany,
        generalParameters: e?.generalParameters,
        homeAccount: e?.homeAccount,
        splitsModalities: e?.splitsModalities,
      })),
    );
  };

  useEffect(() => {
    getBusinesscGroups();
  }, []);

  const getCategories = async () => {
    const response = await httpRequest({
      url: Endpoints.companies.getCategories,
    });
    setCategories(
      response.data?.categories?.map((e) => ({
        id: e.name,
        value: e?.description,
      })),
    );
  };
  useEffect(() => {
    getCategories();
  }, []);

  const RequestCreateEstablishment = useApi(
    Endpoints.establishments.postCreateEstablishment,
    ApiMethod.POST,
  );

  const RequestEditEstablishment = useApi(
    Endpoints.establishments.putEditEstablishment.replace(
      'PARAM_ID',
      state?.id,
    ),
    ApiMethod.PUT,
  );

  const generalDataRef = useRef<{ handleErrors: () => boolean }>();
  const bankDataRef = useRef<{ handleErrors: () => boolean }>();

  const getNestedValue = (obj, path) => {
    return path.reduce(
      (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
      obj,
    );
  };

  const handleErrors = () => {
    const fieldsToCheck = [
      'companyData.addressNumber',
      'companyData.addressState',
      'companyData.addressDistrict',
      'companyData.addressCity',
      'companyData.addressZipCode.masked',
      'companyData.addressStreet',
      'companyData.cnpj.masked',
      'companyData.email',
      'companyData.phone',
      'companyData.tradeName',
      'companyData.fantasyName',
      'responsiblesData.name',
      'responsiblesData.cpf.masked',
      'responsiblesData.dateOfBirth.masked',
      'responsiblesData.occupation',
      'responsiblesData.email',
      'responsiblesData.phone.masked',
      'companyData.partnership',
      'companyData.category',
    ];
    const isAgreement = form?.companyData?.partnership === 'AGREEMENT';

    if (!isAgreement && associateToGroup === true) {
      fieldsToCheck.push(
        'companyData.businessGroupInfoData.businessGroupData.id',
      );
    }

    const errors = {};

    if (!isAgreement && associateToGroup === false) {
      const generalDataErrors = generalDataRef.current?.handleErrors?.() || {};
      Object.assign(errors, generalDataErrors);

      const bankDataErrors = bankDataRef.current?.handleErrors?.() || {};
      Object.assign(errors, bankDataErrors);
    }

    fieldsToCheck.forEach((field) => {
      const value = getNestedValue(form, field.split('.'));
      console.log('VALUE', value);
      if (value === undefined || value === null || value === '') {
        errors[field] = 'Campo obrigatório';
      }
    });

    if (form.responsiblesData?.cpf?.unmasked?.length < 11) {
      errors['responsiblesData.cpf.masked'] = 'CPF inválido';
    }
    if (form.responsiblesData?.phone?.unmasked?.length < 10) {
      errors['responsiblesData.phone.masked'] = 'Celular inválido';
    }
    const cnpjUnmasked = form.companyData?.cnpj?.unmasked ?? '';
    const cnpjLength = cnpjUnmasked.length;
    if (cnpjLength !== 14 && cnpjLength !== 17) {
      errors['companyData.cnpj.masked'] = 'CNPJ inválido';
    } else if (cnpjLength === 17 && cnpjUnmasked.slice(14) === '000') {
      errors['companyData.cnpj.masked'] =
        'Sufixo do CNPJ inválido, deve ser entre 001 e 999';
    }
    if (
      !moment(
        form?.responsiblesData?.dateOfBirth?.masked,
        'DD/MM/YYYY',
      ).isValid()
    ) {
      errors['responsiblesData.dateOfBirth.masked'] = 'Data inválida';
    }
    if (!isEditing && !form.newImages?.length) {
      errors['images'] = 'Pelo menos uma imagem é obrigatória';
    }
    setErrors(errors);

    return Object.keys(errors).length > 0;
  };

  console.log('STATE', state);

  const handleSubmit = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    try {
      const hasMainErrors = handleErrors();
      if (hasMainErrors) return;
      const errorsFromChild = generalAgreementRef?.current?.handleErrors();
      if (errorsFromChild) return;
      const errorsGeneralData = generalDataRef.current?.handleErrors();
      if (errorsGeneralData) return;
      const errorsBankData = bankDataRef.current?.handleErrors();
      if (errorsBankData) return;

      setLoading(true);
      const response = await onSubmitEstabilishment(
        form,
        'juridica',
        state?.id,
      );

      if (response.status >= 404) {
        setLoading(false);

        setDialogError(true);
        setMessageError(response.data.mensagem);
        return;
      }
      if (!isEditing && response?.data?.id) {
        if (form.newImages?.length > 0) {
          const imageResponse = await uploadPhotosOnEstabilishmentCreation(
            form,
            response?.data?.id,
          );
          if (imageResponse.status !== 200) {
            setLoading(false);

            setDialogError(true);
            setMessageError(
              'Houve um erro ao salvar as imagens, tente novamente na tela de edição',
            );
          }
        }
      }
      setDialogError(true);
      setMessageError(
        state?.document
          ? 'Empresa editada com sucesso!'
          : 'Empresa criada com sucesso!',
      );
      setDialogGoBack(true);

      setLoading(false);
    } catch (error) {
      setDialogError(true);
      setMessageError(error?.response?.data?.mensagem ?? 'Houve um erro');
      console.log(error?.message);
      setLoading(false);
    } finally {
      isSubmitting.current = false;
    }
  };

  const handleResendWelcomeEmail = async () => {
    try {
      setLoading(true);

      const response = await httpRequest({
        url: Endpoints.companies.sendNewPasswordByDocument.replace(
          'PARAM_CPF',
          form?.responsiblesData?.cpf.unmasked,
        ),
        method: ApiMethod.POST,
      });

      if (response.status >= 200) {
        setDialogError(true);
        setMessageError('Email de boas-vindas enviado!');
        setDialogGoBack(true);
      } else if (response.status >= 404) {
        setDialogError(true);
        setMessageError(response.data.mensagem);
      }
      setLoading(false);
    } catch (error) {
      setDialogError(true);
      setMessageError(error?.response?.data?.mensagem ?? 'Houve um erro');
      console.log(error?.message);
      setLoading(false);
    }
  };

  const handleChangeType = (value: string) => {
    if (form?.companyData?.partnership === value) return;

    setAssociateToGroup(null);
    setIsMainCompanyAnswered(null);
    setForm((prev) => ({
      ...prev,
      companyData: {
        ...prev.companyData,
        partnership: value,
        ...(value === 'AGREEMENT' && { businessGroupInfoData: null }),
        ...(value === 'COMMERCIAL' && { generalParametersAgreement: null }),
      },
    }));

    if (value !== 'AGREEMENT') {
      validateBusinessGroupByPartnership(value);
    }
  };

  const handleChangeAssociation = (value: boolean) => {
    setAssociateToGroup(value);
    setIsMainCompanyAnswered(null);
    setForm((prev) => ({
      ...prev,
      companyData: {
        ...prev.companyData,
        businessGroupInfoData: value
          ? {
              isCompanyBusinessGroup: false,
              businessGroupData: { id: '', name: '' },
            }
          : null,
      },
    }));
  };

  const handleChangeIsMainCompany = (value: boolean) => {
    setIsMainCompanyAnswered(value);
    setForm((prev) => ({
      ...prev,
      companyData: {
        ...prev.companyData,
        businessGroupInfoData: {
          ...prev.companyData?.businessGroupInfoData,
          isCompanyBusinessGroup: value,
          businessGroupData: { id: '', name: '' },
        },
      },
    }));
  };

  const handleChangeBusinessGroup = (id: string) => {
    setForm((prev) => ({
      ...prev,
      companyData: {
        ...prev.companyData,
        businessGroupInfoData: {
          ...prev.companyData?.businessGroupInfoData,
          businessGroupData: {
            id: id,
            name: '',
          },
        },
      },
    }));

    validateBusinessGroupById(id);
  };

  const validateBusinessGroupByPartnership = (newValue: string) => {
    const hasCommercialType = newValue === 'COMMERCIAL' || newValue === 'ALL';
    const selectedGroupId =
      form?.companyData?.businessGroupInfoData?.businessGroupData?.id;

    if (!selectedGroupId || !hasCommercialType) return;

    const group = groups.find((g) => g.id === selectedGroupId);
    if (!group) {
      setDialogError(true);
      setMessageError(`Ops! Grupo selecionado não encontrado`);
      clearBusinessGroupData();
      return;
    }

    validateGroupStructure(group);
  };

  const validateBusinessGroupById = (groupId: string) => {
    const partnership = form?.companyData?.partnership;
    const hasCommercialType =
      partnership === 'COMMERCIAL' || partnership === 'ALL';

    if (!groupId || !hasCommercialType) return;

    const group = groups.find((g) => g.id === groupId);
    if (!group) {
      setDialogError(true);
      setMessageError(`Ops! Grupo selecionado não encontrado.`);
      clearBusinessGroupData();
      return;
    }

    validateGroupStructure(group);
  };

  const validateGroupStructure = (group: any): boolean => {
    if (isMainCompanyAnswered === true && group.principalGroupCompany) {
      setDialogError(true);
      setMessageError(
        `Ops! O grupo ${group.value} já possui um estabelecimento principal (${group.principalGroupCompany.name})`,
      );
      clearBusinessGroupData();
      return false;
    }

    const { generalParameters, homeAccount, splitsModalities } = group;
    const missingFields: string[] = [];

    if (!generalParameters) missingFields.push('parâmetros gerais');
    if (!homeAccount) missingFields.push('domicílio bancário');
    if (!splitsModalities) missingFields.push('taxas de administração');

    if (missingFields.length > 0) {
      const formatMessage = (items: string[]): string => {
        if (items.length === 1) {
          const item = items[0];
          const article = item.startsWith('parâmetros') ? '' : 'o ';
          const adjective = item.startsWith('taxas') ? 'definidas' : 'definido';
          return `Ops! O grupo ${group.value} não possui ${article}${item} ${adjective}`;
        }

        const formattedList =
          items.length === 2
            ? `${items[0]} e ${items[1]}`
            : `${items.slice(0, -1).join(', ')} e ${items[items.length - 1]}`;

        return `Ops! O grupo ${group.value} não possui ${formattedList} definidos`;
      };

      setDialogError(true);
      setMessageError(formatMessage(missingFields));
      clearBusinessGroupData();
      return false;
    }

    return true;
  };

  const clearBusinessGroupData = () => {
    setForm((prev) => ({
      ...prev,
      companyData: {
        ...prev.companyData,
        businessGroupInfoData: {
          ...prev.companyData?.businessGroupInfoData,
          businessGroupData: {
            id: '',
            name: '',
          },
        },
      },
    }));
  };

  const hasGeneralParametersAgreement = () => {
    const partnership = form?.companyData?.partnership;
    if (partnership === 'AGREEMENT') return true;
    return partnership === 'ALL' && associateToGroup !== null;
  };

  const hasGeneralParametersCommercial = () => {
    const partnership = form?.companyData?.partnership;
    return (
      associateToGroup === false &&
      (partnership === 'COMMERCIAL' || partnership === 'ALL')
    );
  };

  return (
    <>
      <Loading
        status={
          RequestCreateEstablishment.loading ||
          RequestEditEstablishment.loading ||
          loading
        }
      />
      <MapLocationModal
        open={openMap}
        onClose={() => setOpenMap(false)}
        searchQuery={buildAddressQuery()}
        initialLatLng={
          form?.companyData?.addressLatitude &&
          form?.companyData?.addressLongitude
            ? [
                form.companyData.addressLatitude,
                form.companyData.addressLongitude,
              ]
            : null
        }
        onConfirm={handleSelectLocation}
      />
      <Dialog
        icon={icons.exclamation}
        open={dialogError}
        positiveLabel="Entendi"
        positiveAction={() => {
          setDialogError(false);
          dialogGoBack && history.push('/teu-pag/estabelecimento');
        }}
        message={messageError}
      />
      <ContainerFlex>
        <Grid xs={1} sm={1} lg={2} gap={16}>
          <ContainerFlex>
            <ContainerFlex>
              <Input
                label="CNPJ"
                name="companyData.cnpj"
                placeholder="00.000.000/0000-00 000"
                maxLength={22}
                disabled={isEditing}
                value={
                  cpfCnpjExtendedMask(form?.companyData?.cnpj?.unmasked).masked
                }
                onChange={handleChange}
                mask={MaskTypes.CNPJ_EXTENDED}
                errorMessage={errors['companyData.cnpj.masked']}
                autoComplete="off"
              />
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="Razão Social"
                name="companyData.tradeName"
                value={form?.companyData?.tradeName}
                onChange={handleChange}
                errorMessage={errors['companyData.tradeName']}
              />
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="Nome fantasia"
                name="companyData.fantasyName"
                value={form?.companyData?.fantasyName}
                onChange={handleChange}
                errorMessage={errors['companyData.fantasyName']}
              />
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="Telefone empresarial"
                name="companyData.phone"
                value={form?.companyData?.phone?.masked}
                placeholder="(00) 00000-0000"
                maxLength={15}
                onChange={handleChange}
                mask={MaskTypes.PHONE}
                errorMessage={errors['companyData.phone.masked']}
              />
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="E-mail empresarial"
                name="companyData.email"
                value={form?.companyData?.email}
                onChange={handleChange}
                errorMessage={errors['companyData.email']}
              />
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex>
            <ContainerFlex row align="flex-end" gap="16">
              <ContainerFlex>
                <Input
                  label="CEP"
                  name="companyData.addressZipCode"
                  placeholder="00000-000"
                  value={form?.companyData?.addressZipCode?.masked}
                  onChange={handleChange}
                  maxLength={9}
                  mask={MaskTypes.CEP}
                  errorMessage={errors['companyData.addressZipCode.masked']}
                />
              </ContainerFlex>
              {/* <Button
                fitContent
                onClick={handleGetCep}
                disabled={
                  form?.companyData?.addressZipCode?.unmasked?.length !== 8
                }
                style={{ gap: 10 }}
              >
               <FaSearch style={{marginRight: 10}}/>
                Buscar CEP
              </Button> */}
              <Button
                fitContent
                onClick={() => setOpenMap(true)}
                style={{ gap: 16, width: '40%', whiteSpace: 'nowrap', fontSize: 'clamp(0.7rem, 1.2vw, 1rem)'}}
              >
                <FaMapMarkerAlt style={{marginRight: 12}}/>
                Buscar no mapa
              </Button>
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="Endereço"
                name="companyData.addressStreet"
                value={form?.companyData?.addressStreet}
                onChange={handleChange}
                errorMessage={errors['companyData.addressStreet']}
              />
            </ContainerFlex>
            <ContainerFlex row space gap="24">
              <ContainerFlex>
                <Input
                  label="Número"
                  name="companyData.addressNumber"
                  value={form?.companyData?.addressNumber}
                  onChange={handleChange}
                  errorMessage={errors['companyData.addressNumber']}
                />
              </ContainerFlex>
              <ContainerFlex>
                <Input
                  label="Complemento"
                  name="companyData.addressComplement"
                  value={form?.companyData?.addressComplement}
                  onChange={handleChange}
                />
              </ContainerFlex>
            </ContainerFlex>
            <ContainerFlex row space gap="24">
              <ContainerFlex>
                <Input
                  label="Cidade"
                  name="companyData.addressCity"
                  value={form?.companyData?.addressCity}
                  onChange={handleChange}
                  errorMessage={errors['companyData.addressCity']}
                />
              </ContainerFlex>
              <ContainerFlex>
                <Input
                  label="Bairro"
                  name="companyData.addressDistrict"
                  value={form?.companyData?.addressDistrict}
                  onChange={handleChange}
                  errorMessage={errors['companyData.addressDistrict']}
                />
              </ContainerFlex>
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="Estado"
                name="companyData.addressState"
                value={form?.companyData?.addressState}
                onChange={handleChange}
                errorMessage={errors['companyData.addressState']}
              />
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex marginTop={6}>
            <ContainerFlex>
              <Select
                label="Segmento"
                name="companyData.category"
                options={categories}
                value={form?.companyData?.category}
                onChange={(v) =>
                  handleChange({
                    target: {
                      name: 'companyData.category',
                      value: v,
                    },
                  })
                }
                errorMessage={errors['companyData.category']}
              />
            </ContainerFlex>
          </ContainerFlex>
        </Grid>
        <ContainerFlex flex={1} marginTop={40} marginBottom={30}>
          <EstabilishmentImages
            company={form}
            setForm={setForm}
            errorMessage={errors['images']}
          />
        </ContainerFlex>
        <ContainerFlex marginTop={40} marginBottom={30}>
          <h3>Dados do representante/contato</h3>
        </ContainerFlex>
        <Grid xs={1} sm={2} lg={2} gap={16}>
          <ContainerFlex>
            <ContainerFlex>
              <Input
                label="CPF"
                disabled={isEditing}
                name="responsiblesData.cpf"
                maxLength={14}
                placeholder="000.000.000-00"
                value={form?.responsiblesData?.cpf?.masked}
                onChange={handleChange}
                mask={MaskTypes.CPF}
                errorMessage={errors['responsiblesData.cpf.masked']}
              />
            </ContainerFlex>
            <ContainerFlex>
              <Input
                disabled={isEditing}
                label="Nome completo"
                name="responsiblesData.name"
                value={form?.responsiblesData?.name}
                onChange={handleChange}
                errorMessage={errors['responsiblesData.name']}
              />
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="Telefone de contato"
                name="responsiblesData.phone"
                value={form?.responsiblesData?.phone?.masked}
                placeholder="(00) 00000-0000"
                maxLength={15}
                onChange={handleChange}
                mask={MaskTypes.PHONE}
                errorMessage={errors['responsiblesData.phone.masked']}
              />
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex>
            <ContainerFlex>
              <Input
                label="Data de nascimento"
                name="responsiblesData.dateOfBirth"
                value={form?.responsiblesData?.dateOfBirth?.masked}
                onChange={handleChange}
                maxLength={10}
                mask={MaskTypes.DATE}
                errorMessage={errors['responsiblesData.dateOfBirth.masked']}
              />
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="E-mail de contato"
                name="responsiblesData.email"
                value={form?.responsiblesData?.email}
                onChange={handleChange}
                errorMessage={errors['responsiblesData.email']}
              />
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="Cargo"
                name="responsiblesData.occupation"
                value={form?.responsiblesData?.occupation}
                onChange={handleChange}
                errorMessage={errors['responsiblesData.occupation']}
              />
            </ContainerFlex>
          </ContainerFlex>
        </Grid>

        <ContainerFlex marginTop={40} marginBottom={30}>
          <h3>Tipo de parceiro</h3>
        </ContainerFlex>

        <ContainerFlex row align="center" style={{ gap: '24px' }}>
          <label>
            <ContainerFlex row horizontal align="center">
              <RadioButton
                disabled={isEditing}
                name="partnerType"
                value="COMMERCIAL"
                checked={form?.companyData?.partnership === 'COMMERCIAL'}
                onChange={() => handleChangeType('COMMERCIAL')}
              />
              Comercial
            </ContainerFlex>
          </label>

          <label>
            <ContainerFlex row horizontal align="center">
              <RadioButton
                disabled={isEditing}
                name="partnerType"
                value="AGREEMENT"
                checked={form?.companyData?.partnership === 'AGREEMENT'}
                onChange={() => handleChangeType('AGREEMENT')}
              />
              Convênio
            </ContainerFlex>
          </label>

          <label>
            <ContainerFlex row horizontal align="center">
              <RadioButton
                disabled={isEditing}
                name="partnerType"
                value="ALL"
                checked={form?.companyData?.partnership === 'ALL'}
                onChange={() => handleChangeType('ALL')}
              />
              Todos
            </ContainerFlex>
          </label>
        </ContainerFlex>
        <div style={{ position: 'relative' }}>
          <span
            style={{
              color: 'red',
              position: 'absolute',
              bottom: '-15px',
              fontSize: '12px',
            }}
          >
            {errors['companyData.partnership']}
          </span>
        </div>

        {form?.companyData?.partnership &&
        form?.companyData?.partnership !== 'AGREEMENT' &&
        !state?.document ? (
          <ContainerFlex
            marginTop={40}
            marginBottom={
              hasGeneralParametersCommercial() ||
              hasGeneralParametersAgreement()
                ? 0
                : 30
            }
          >
            <Grid xs={1} sm={2} lg={2} gap={16}>
              <ContainerFlex>
                <Select
                  disabled={isEditing}
                  label="Associar a um grupo econômico?"
                  options={[
                    { value: 'SIM', id: true },
                    { value: 'NÃO', id: false },
                  ]}
                  value={associateToGroup}
                  onChange={(v) => handleChangeAssociation(v as boolean)}
                />
              </ContainerFlex>
              {associateToGroup === true && (
                <ContainerFlex>
                  <Select
                    disabled={isEditing}
                    label="Empresa principal do grupo?"
                    options={[
                      { value: 'SIM', id: true },
                      { value: 'NÃO', id: false },
                    ]}
                    value={isMainCompanyAnswered}
                    onChange={(v) => handleChangeIsMainCompany(v as boolean)}
                  />
                </ContainerFlex>
              )}
              {associateToGroup === true && isMainCompanyAnswered !== null && (
                <ContainerFlex marginTop={5}>
                  <Select
                    disabled={isEditing}
                    label="Grupo para vincular"
                    options={groups}
                    name="companyData.businessGroupInfoData.businessGroupData.id"
                    value={
                      form?.companyData?.businessGroupInfoData
                        ?.businessGroupData?.id
                    }
                    onChange={(e) => handleChangeBusinessGroup(e)}
                    errorMessage={
                      errors[
                        'companyData.businessGroupInfoData.businessGroupData.id'
                      ]
                    }
                  />
                </ContainerFlex>
              )}
            </Grid>
          </ContainerFlex>
        ) : null}

        {hasGeneralParametersCommercial() && !state?.document ? (
          <ContainerFlex marginTop={40} marginBottom={30}>
            <ContainerFlex>
              <h3>Parâmetros Gerais Comercial</h3>

              <GeneralData
                ref={generalDataRef}
                onChange={(values) =>
                  setForm((prev) => ({
                    ...prev,
                    companyData: {
                      ...prev.companyData,
                      generalParametersData: values,
                    },
                  }))
                }
                defaultValues={form?.companyData?.generalParametersData}
              />
            </ContainerFlex>
            <ContainerFlex>
              <h3>Dados da conta domicílio</h3>

              <BankData
                ref={bankDataRef}
                onChange={(values) =>
                  setForm((prev) => ({
                    ...prev,
                    bankData: {
                      ...values,
                    },
                  }))
                }
                defaultValues={form?.bankData}
              />
            </ContainerFlex>
            <ContainerFlex>
              <h3>Taxa de administração (MDR)</h3>

              <MDRData
                onChange={(values) =>
                  setForm((prev) => ({
                    ...prev,
                    companyData: {
                      ...prev.companyData,
                      splitsModalities: values,
                    },
                  }))
                }
                defaultValues={form.companyData?.splitsModalities}
              />
            </ContainerFlex>
          </ContainerFlex>
        ) : null}

        {hasGeneralParametersAgreement() && !state?.document ? (
          <ContainerFlex
            marginTop={40}
            marginBottom={hasGeneralParametersAgreement() ? 0 : 30}
          >
            <ContainerFlex>
              <h3>Parâmetros Gerais Convênio</h3>
            </ContainerFlex>

            <GeneralAgreementData
              ref={generalAgreementRef}
              onChange={(values) =>
                setForm((prev) => ({
                  ...prev,
                  companyData: {
                    ...prev.companyData,
                    generalParametersAgreement: values,
                  },
                }))
              }
              errors={errors}
              defaultValues={form?.companyData?.generalParametersAgreement}
            />
          </ContainerFlex>
        ) : null}

        <ContainerFlex row end marginTop={30} marginBottom={30} gap="20" style={{ flexWrap: 'wrap', justifyContent: 'flex-start', alignItems: 'center' }}>
          <Button outlined fitContent onClick={() => history.goBack()}>
            Voltar
          </Button>
          {state?.document && form?.companyData?.cnpj && (
            <Button onClick={handleResendWelcomeEmail}>
              Reenviar e-mail de boas-vindas
            </Button>
          )}
          <Button fitContent onClick={handleSubmit} disabled={loading}>
            {state?.document && form?.companyData?.cnpj ? (
              <span>Salvar</span>
            ) : (
              <span>Cadastrar</span>
            )}
          </Button>
          <ChangeStatusModal
            form={form}
            onStatusChanged={handleStatusChanged}
          />
        </ContainerFlex>
        <ShowWhereIsAcceptedToogle
          form={form}
          onStatusChanged={handleWhereAcceptedChanged}
        />
      </ContainerFlex>
    </>
  );
};

export default CNPJEstablishment;
